import React from "react";

const CoinWalletSupportIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41 27.7471C41 21.7709 36.9733 16.5496 31.2949 14.9762C30.938 6.65775 24.06 0 15.6553 0C7.02279 0 0 7.02279 0 15.6553C0 18.4686 0.748856 21.2079 2.17087 23.6127L0.0575562 31.2527L7.69782 29.1397C9.90842 30.4469 12.4021 31.1832 14.9759 31.2943C16.549 36.9729 21.7706 41 27.7471 41C30.1325 41 32.4523 40.3647 34.4905 39.1576L40.9421 40.9421L39.1576 34.4905C40.3647 32.4523 41 30.1325 41 27.7471ZM8.07694 26.5421L3.50311 27.8074L4.7684 23.2336L4.48 22.7825C3.12086 20.6561 2.40234 18.1915 2.40234 15.6553C2.40234 8.34752 8.34752 2.40234 15.6553 2.40234C22.963 2.40234 28.9082 8.34752 28.9082 15.6553C28.9082 22.963 22.963 28.9082 15.6553 28.9082C13.119 28.9082 10.6548 28.1897 8.52801 26.8306L8.07694 26.5421ZM37.4969 37.4969L34.103 36.5579L33.6497 36.8528C31.8927 37.9943 29.8513 38.5977 27.7471 38.5977C23.05 38.5977 18.9225 35.5606 17.4602 31.2058C24.6528 30.3765 30.3765 24.6528 31.2061 17.4598C35.5606 18.9225 38.5977 23.05 38.5977 27.7471C38.5977 29.8513 37.9943 31.8927 36.8528 33.6497L36.5579 34.103L37.4969 37.4969Z"
      fill="#181818"
    />
    <path
      d="M14.4541 21.7012H16.8564V24.1035H14.4541V21.7012Z"
      fill="#181818"
    />
    <path
      d="M18.0576 12.0117C18.0576 12.6939 17.7798 13.3236 17.2756 13.785L14.4541 16.3675V19.2988H16.8564V17.4254L18.8975 15.5574C19.8903 14.6487 20.46 13.3565 20.46 12.0117C20.46 9.36226 18.3047 7.20703 15.6553 7.20703C13.0058 7.20703 10.8506 9.36226 10.8506 12.0117H13.2529C13.2529 10.687 14.3305 9.60938 15.6553 9.60938C16.98 9.60938 18.0576 10.687 18.0576 12.0117Z"
      fill="#181818"
    />
  </svg>
);

export default CoinWalletSupportIcon;
